import * as CL from '@design-system/component-library';

export const OpenFormIcon = ({ icon, size = 'l', type = 'filled', ...props }: CL.IconProps) => (
  <CL.Icon {...props} key={icon} icon={icon} size={size} type={type} />
);
